import React, { useState } from 'react';

interface PairingFormProps {
  onSubmit: (query: string) => void;
  isLoading: boolean;
}

const PairingForm: React.FC<PairingFormProps> = ({ onSubmit, isLoading }) => {
  const [query, setQuery] = useState<string>('');

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!query.trim()) return; // Prevent submitting empty queries
    onSubmit(query);
  };

  return (
    // Use Materialize row/col for structure if needed, or just form elements
    <form onSubmit={handleSubmit} className="card-panel"> {/* Add card panel for background */}
       <div className="input-field col s12"> {/* Input field wrapper */}
          {/* Use i tag for icon */}
          <i className="material-icons prefix">mode_edit</i>
          <textarea
            id="pairingQuery"
            className="materialize-textarea" // Materialize class
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            disabled={isLoading}
            style={{ minHeight: '60px' }} // Ensure decent height
          />
          {/* Label should come *after* input in Materialize */}
          <label htmlFor="pairingQuery" className={query ? 'active' : ''}>
             Inserisci il cibo o l'occasione (es., risotto ai carciofi...)
          </label>
       </div>
       <div className="btn-container"> {/* Container for button alignment */}
          <button
            type="submit"
            className={`btn waves-effect waves-light ${isLoading ? 'disabled' : 'teal'}`} // Materialize button classes
            disabled={isLoading}
          >
            {isLoading ? 'Sto cercando...' : 'Trova Abbinamento'}
            <i className="material-icons right">send</i> {/* Add send icon */}
          </button>
       </div>
    </form>
  );
};

export default PairingForm;
